import { notification } from "antd";
import moment from "moment-timezone";

const requestCacheService = {};

/*
    Ajuda a fazer cache de requisições. Usar apenas em requisições que não mudam quase nunca.
*/
requestCacheService.cacheRequest = async (
	key,
	callback,
	secondsToExpire = 86400,
) => {
	let data = null;
	let dateToExpire = null;

	try {
		const cachedData = await localStorage.getItem("cache_" + key);
		const rawExpire = await localStorage.getItem("cache_" + key + "_expire");

		if (typeof cachedData === "string") {
			try {
				data = JSON.parse(cachedData);
			} catch {
				data = null;
			}
		}

	if (rawExpire) {
		const parsedIso = moment(rawExpire, moment.ISO_8601, true);
		const parsedFallback = moment(rawExpire, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ", true);
		if (parsedIso.isValid()) {
			dateToExpire = parsedIso;
		} else if (parsedFallback.isValid()) {
			dateToExpire = parsedFallback;
		} else {
			dateToExpire = null;
		}
	}

		if (data && dateToExpire && moment().isBefore(dateToExpire)) {
			return data;
		}
	} catch {
		data = null;
		dateToExpire = null;
	}

	const freshData = await callback();
	await localStorage.setItem("cache_" + key, JSON.stringify(freshData));
	await localStorage.setItem(
		"cache_" + key + "_expire",
		moment().add(secondsToExpire, "seconds").toISOString(),
	);

	return freshData;
};

requestCacheService.limparCache = async () => {
	const cacheKeys = Object.keys(localStorage).filter((key) =>
		key.includes("cache_"),
	);

	for (const key of cacheKeys) {
		await localStorage.removeItem(key);
	}

	notification.success({ message: "Cache limpo com sucesso" });
};

export default requestCacheService;
